let Widget3dsoft = require('./Main.js');

    /**
     * 
     * @returns {undefined}
     */
Widget3dsoft.prototype.showFormInterventions = function(){

    if (this.verifStepClientDone()) {
        var self = this;
        
        //Si on a pas le modele ou marque on reoriente vers l'etape vehicule
        if (    (       self.oSite.bIdentifierVehicule
                    &&  (    self.rendezvous.iIdModele == undefined || self.rendezvous.iIdModele == ''
                            && self.rendezvous.iIdMarque == undefined || self.rendezvous.iIdMarque == '')
                )
                || !self.oSite.bIdentifierVehicule 
                    && (self.rendezvous.sModeleLibelle == '' || self.rendezvous.sModeleLibelle == '' )
                    && (self.rendezvous.sMarqueLibelle == '' || self.rendezvous.sMarqueLibelle == '' )
            ) {
            self.showFormVehicule(true);
        } else {
            $(self.sClass + ' .widget3Dsoft-loading').show();
            fCallbackFormIntervention = function (response) {
                    $(self.sClass).html(response);
                    self.displayInterventions(self.rendezvous.iIdModele);
                    $(self.sClass + ' .widget3Dsoft-imgadditv').html('<img src="' + self.sServerURL + 'img/plus16.png">');
                    self.filArianne(self,'stepMotif');
                    self.completeFooter();
                    self.headerProfil(self);

                    if (self.rendezvous.sCommentaire !== null) {
                        $(self.sClass + ' .widget3Dsoft-commentaire').val(self.rendezvous.sCommentaire);
                    }
                    
                    $(self.sClass + ' .addIntervention').click(function(){
                        self.addIntervention(self);
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-btnValiderIntervention').click(function(){
                        self.btnValiderIntervention(self);
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-loading').hide();
            };
            
            //if we have the html in cache we use it
            if(self.sHtmlFormIntervention != undefined){
                fCallbackFormIntervention(self.sHtmlFormIntervention);
            }else{
                self.ajax('GET',
                self.sServerURL + 'widget/form-interventions' + self.sParamsGet,
                {},
                function (response) {
                        self.sHtmlFormIntervention = response;
                        fCallbackFormIntervention(response);
                });
            }
            
        }
    }
};


    /**
     * 
     * @returns {undefined}
     */
Widget3dsoft.prototype.displayInterventions = function (iIdModele) {
    var self = this;
    if (iIdModele === undefined || iIdModele == null || iIdModele == '') {
        iIdModele = self.rendezvous.iIdModele;
    }

    //Si on a deja  charge les interventions et deja  des valeurs dans les interventions du rendez-vous
    if (self.aInterventions.length > 0 && (self.rendezvous.aInterventions.length > 0 || (self.rendezvous.aTravaux.length != undefined && self.rendezvous.aTravaux.length > 0) )) {
        console.log('in first if');
        self.iNbSelectInterventions = 0;
        self.addTravaux(self, self.rendezvous.aTravaux);
        for (iIdIntervention in self.rendezvous.aInterventions) {
            self.addIntervention(self, self.rendezvous.aInterventions[iIdIntervention]);
        }
        
        self.setDureeTotale(self);

    } else {
        self.ajax('POST',
                this.sServerURL + 'rest/interventions/search' + this.sParamsGet,
                {
                    iIdModele: iIdModele,
                    iIdVeh: self.rendezvous.iIdVehicule
                },
                function (response, statut) {
                    if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
                    }
                    if (response.success === true) {

                    //Keep intervention list in this object
                    self.oListeInterventions = new ListeInterventions();
                    self.oListeInterventions.aInterventions = response.datas.aInterventions;
                    self.aOpcNotDoublons = response.datas.aOpcNotDoublons;
                    if (self.rendezvous.aInterventions.length > 0 || (self.rendezvous.aTravaux != undefined && self.rendezvous.aTravaux.length > 0)) {
                        self.iNbSelectInterventions = 0;
                        

                        self.addTravaux(self, self.rendezvous.aTravaux);
                        
                        for (iIdIntervention in self.rendezvous.aInterventions) {
                            self.addIntervention(self, self.rendezvous.aInterventions[iIdIntervention]);
                        }
                        
                    } else {
                        self.addIntervention(self);
                    }
                    self.setDureeTotale(self);

                }
        },true);
    }

};

Widget3dsoft.prototype.searchInterventions = function (self, iIdModele,callback) {
    
     self.ajax('POST',
                    this.sServerURL + 'rest/interventions/search' + this.sParamsGet,
                    { iIdModele: iIdModele },
                    function (response, statut) {
                        if (bIEOld3Dsoft) {
                            response = JSON.parse(response);
                        }
                        if (response.success === true) {

                           self.oListeInterventions = new ListeInterventions();
                           self.oListeInterventions.aInterventions = response.datas.aInterventions;
                           self.aOpcNotDoublons = response.datas.aOpcNotDoublons;
                           if (response.success == true) {
                               callback(response.datas.aVehicules);
                           }

                }
    },true);
    
        
    return self.oListeInterventions;
}

    /**
     * 
     * @param {type} self
     * @param {type} iNumIntervention identify each select has changed
     * @returns {undefined}
     */
Widget3dsoft.prototype.changeIntervention = function (self, iNumIntervention) {

    var iIdInterventions = $(self.sClass + ' .widget3Dsoft-intervention_' + iNumIntervention).val();
    
    var oIntevention = self.oListeInterventions.getIntervention(iIdInterventions);
    var iDuree = (iIdInterventions == "") ? 0 : oIntevention.duree;
    var iH = parseInt(iDuree / 60);
    var iMins = parseInt(iDuree % 60);
    var sMins = (iMins < 10) ? '0' + iMins : iMins;


    //Calc the total duration
    var iDureeTotale = 0;
    $('select[name^="widget3Dsoft-intervention"]').each(function () {
        if ($(this).val() !== '') {
            oItv = self.oListeInterventions.getIntervention($(this).val());
            iDureeTotale += parseInt(oItv.duree);
        }
    });

    for(iKeyTravaux in self.rendezvous.aTravaux){
        iDureeTotale += parseInt(self.rendezvous.aTravaux[iKeyTravaux].iDureePrevue);
    }

    var iHTotale = parseInt(iDureeTotale / 60);
    var iMinsTotale = parseInt(iDureeTotale % 60);
    var sMinsTotale = (iMinsTotale < 10) ? '0' + iMinsTotale : iMinsTotale;

    $(self.sClass + ' .widget3Dsoft-totalDuree').html(iHTotale + 'h' + sMinsTotale);
    $(self.sClass + ' .widget3Dsoft-itvduree_' + iNumIntervention).html(iH + 'h' + sMins);
};


Widget3dsoft.prototype.setDureeTotale = function (self) {
    
    //Calc the total duration
    var iDureeTotale = 0;
    $('select[name^="widget3Dsoft-intervention"]').each(function () {
        if ($(this).val() !== '') {
            var oItv = self.oListeInterventions.getIntervention($(this).val());
            iDureeTotale += parseInt(oItv.duree);
        }
    });

    for(iKeyTravaux in self.rendezvous.aTravaux){
        iDureeTotale += parseInt(self.rendezvous.aTravaux[iKeyTravaux].iDureePrevue);
    }

    var iHTotale = parseInt(iDureeTotale / 60);
    var iMinsTotale = parseInt(iDureeTotale % 60);
    var sMinsTotale = (iMinsTotale < 10) ? '0' + iMinsTotale : iMinsTotale;

    $(self.sClass + ' .widget3Dsoft-totalDuree').html(iHTotale + 'h' + sMinsTotale);
}

    /**
     * 
     * @param widget3Dsoft self
     * @returns {undefined}
     */
Widget3dsoft.prototype.addIntervention = function (self, iIdInterventionSelected) {

    if (self.iNbSelectInterventions < self.iMAXNbSelectInterventions) {
        self.iNbSelectInterventions++;
        
        var sHtmlSelectItv = '<div class="widget3Dsoft-row_intervention_' + self.iNbSelectInterventions + ' row padding-top-10">';
        sHtmlSelectItv += ' <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">';
        sHtmlSelectItv += '     <select name="widget3Dsoft-intervention[]" class="widget3Dsoft-intervention_' + self.iNbSelectInterventions + ' pointer form-control"';
        sHtmlSelectItv += '             onChange="' + self.sVarName + '.changeIntervention(' + self.sVarName + ',' + self.iNbSelectInterventions + ');">';

        sHtmlSelectItv += '     <option value="">' + self.sLanguage.INTERVENTIONS_MSG_SELECTIONNER_INTERVENTION + '</option>';
        for(iItv in self.oListeInterventions.aInterventions){
            sHtmlSelectItv += '     <option value="' + self.oListeInterventions.aInterventions[iItv].iId + '">' + self.oListeInterventions.aInterventions[iItv].libelle + '</option>';
        };

        sHtmlSelectItv += '     </select>';
        sHtmlSelectItv += ' </div>';
        
        sHtmlSelectItv += ' <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">';
        sHtmlSelectItv += ' <span class="widget3Dsoft-itvduree_' + self.iNbSelectInterventions + '">0h00</span>';
        if (self.iNbSelectInterventions > 1) {
            sHtmlSelectItv += ' <img src="' + self.sServerURL + 'img/moins16.png" class="pointer" onClick="' + self.sVarName + '.removeIntervention(' + self.sVarName + ',' + self.iNbSelectInterventions + ')">';
        }

        sHtmlSelectItv += '</div>';
        sHtmlSelectItv += '</div>';
        $(self.sClass + ' .widget3Dsoft-listInterventions').append(sHtmlSelectItv);

        //Si on a une valeure  selectionner on la selectionne et on utilise changeIntervention pour calculer la durÃƒÂ©e
        if (iIdInterventionSelected !== undefined) {
            $(self.sClass + ' .widget3Dsoft-intervention_' + self.iNbSelectInterventions).val(iIdInterventionSelected);
            self.changeIntervention(self, self.iNbSelectInterventions);
        }

    } else {
        $(self.sClass + ' .widget3Dsoft-linkAddItv').hide();
        $(self.sClass + ' .widget3Dsoft-noMoreThan5Itv').show();
    }
    self.adaptDimensions(self);

};
    
Widget3dsoft.prototype.addTravaux = function (self, aTravaux) {
   
    if (aTravaux != undefined && aTravaux.length > 0){
        self.alertMessage(self, self.sLanguage.INTERVENTION_MSG_TRAVAUX_NO_UPDATE);
        for(iKeyTravaux in aTravaux){
            self.iNbSelectInterventions++;
            var sHtmlSelectItv = '<div class="row padding-top-10">';

            sHtmlSelectItv += ' <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">';
            sHtmlSelectItv += aTravaux[iKeyTravaux]._INT_LIBELLE;
            sHtmlSelectItv += '</div>';

            aDuree = self.convertMinToHour(aTravaux[iKeyTravaux].iDureePrevue);
            sHtmlSelectItv += ' <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">';
            sHtmlSelectItv +=  aDuree.sHeures + 'h' + aDuree.sMins;
            sHtmlSelectItv += '</div>';

            sHtmlSelectItv += '</div>';
            $(self.sClass + ' .widget3Dsoft-listInterventions').append(sHtmlSelectItv);
        }
    }
    
    self.adaptDimensions(self);
 
};

    /**
     * 
     * @param widget3Dsoft self
     * @param {type} iNumLigne
     * @returns {undefined}
     */
Widget3dsoft.prototype.removeIntervention = function (self, iNumLigne) {
    //$(self.sClass + ' .widget3Dsoft-intervention_'+self.iNbSelectInterventions).remove();
    $(self.sClass + ' .widget3Dsoft-row_intervention_' + iNumLigne).remove();

    var iDureeTotale = 0;
    $(self.sClass + ' select[name^="widget3Dsoft-intervention"]').each(function () {
        if ($(this).val() !== '') {
            oItv = self.oListeInterventions.getIntervention($(this).val());
            iDureeTotale += oItv.duree;
        }
    });

    var iHTotale = parseInt(iDureeTotale / 60);
    var iMinsTotale = parseInt(iDureeTotale % 60);
    var sMinsTotale = (iMinsTotale < 10) ? '0' + iMinsTotale : iMinsTotale;

    $(self.sClass + ' .widget3Dsoft-totalDuree').html(iHTotale + 'h' + sMinsTotale);

    self.iNbSelectInterventions--;
    $(self.sClass + ' .widget3Dsoft-linkAddItv').show();
    $(self.sClass + ' .widget3Dsoft-noMoreThan5Itv').hide();
    
    //The code before has to be refactored to use only this line for the total
    self.setDureeTotale(self);
    
};

    /**
     * 
     * @param widget3Dsoft self
     * @returns {undefined}
     */
Widget3dsoft.prototype.btnValiderIntervention = function (self) {
    self.rendezvous.aInterventions = [];
    $(self.sClass + ' select[name^="widget3Dsoft-intervention"]').each(function () {
        if ($(this).val() != '') {
            self.rendezvous.aInterventions.push($(this).val());
        }
    });

    self.rendezvous.sCommentaire = $(self.sClass + ' .widget3Dsoft-commentaire').val();
    if (self.rendezvous.aInterventions.length > 0) {
        self.showFormDate();
    } else {
        $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.INTERVENTIONS_MSG_CHOISIR_AU_MOINS_UNE);
        $(self.sClass + ' .widget3Dsoft-message').show();
    }

};
    
    

Widget3dsoft.prototype.getDureeTotale = function (self) {
    
    //Calc the total duration
    var iDureeTotale = 0;
    for (iKeyIntervention in self.rendezvous.aInterventions) {
        var iIdIntervention = self.rendezvous.aInterventions[iKeyIntervention];
        var oIntervention = self.oListeInterventions.getIntervention(iIdIntervention);
        iDureeTotale += parseInt(oIntervention.duree);
    }
    
    for(iKeyTravaux in self.rendezvous.aTravaux){
            iDureeTotale += parseInt(self.rendezvous.aTravaux[iKeyTravaux].iDureePrevue);
    }
    
    return iDureeTotale;
}
